export default __webpack_public_path__ + "static/media/theme8.dc8998d4.jpg";